import React from "react";
import Navigation from "./navigation";
import NavInfoAutograder from "./navInfoAutograder";
import { useParams } from "react-router-dom";
import vidTypes from "./vidTypes";
import YouTubeEmbed from "./youtubeEmbed";

const Videos = () => {
    const { video } = useParams();

    const ret_correct_video_id = () => {
        if (video === vidTypes.DEMO) {
            return "UEI56gJKdoU";
        } else if (video === vidTypes.POLL_MODE) {
            return "3UfzCxzxZL0"
        } else if (video === vidTypes.LAMBDA) {
            return "Ap4AImZlFpc"
        } else if (video === vidTypes.DOCKERFILE) {
            return "Ni5pUEtYbi8"
        } else if (video === vidTypes.LOGS) {
            return "dnlQyH5DRr0"
        } else if (video === vidTypes.PROGRAMMING) {
            return "lafa7PUUG_g"
        } else if (video === vidTypes.ZIP_FILE) {
            return "paj2N9NNd3k"
        } else {
            return "DNE-Video"
        }
    }

    const ret_name = () => {
        if (video === vidTypes.DEMO) {
            return "Quick Demo";
        } else if (video === vidTypes.POLL_MODE) {
            return "Poll Mode Tutorial"
        } else if (video === vidTypes.LAMBDA) {
            return "Lambda Tutorial"
        } else if (video === vidTypes.DOCKERFILE) {
            return "Dockerfile Tutorial"
        } else if (video === vidTypes.LOGS) {
            return "Research Code Logs Tutorial"
        } else if (video === vidTypes.PROGRAMMING) {
            return "Programming Questions Tutorial"
        } else if (video === vidTypes.ZIP_FILE) {
            return "Programming Zip File Tutorial"
        } else {
            return "404 Video"
        }
    }

    return (
        <>
            <Navigation info={<NavInfoAutograder />}/>
            <div className="autograder-container">
                <div className="autograder-documentation" style={{ maxWidth: "none" }}>
                    <span style={{ fontWeight: "500", fontSize: "var(--font-size-two)" }}>
                        {ret_name()}:
                    </span>
                    <div className="youtube-wrapper">
                        <YouTubeEmbed videoId={ret_correct_video_id()}/>
                    </div>
                </div>            
            </div>
        </>
    );
}

export default Videos;